import { TranslateResult } from "vue-i18n";
import { RawLocation } from "vue-router/types/router";

export enum CreatorsTabsEnum {
  ALL = "ALL",
  ONLINE = "ONLINE",
  LIVE = "LIVE",
  RECENTLY_ACTIVE = "RECENTLY_ACTIVE",
}

export type CreatorsListTab = {
  value: CreatorsTabsEnum;
  name: TranslateResult;
  to: RawLocation;
};
